import React from 'react';
import { SvgIconProps, fade } from '@material-ui/core';
import styled from 'styled-components';

const CircleIcon = styled.div`
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ theme }) => `
        width: ${theme.spacing(3)}px;
        height: ${theme.spacing(3)}px;
        background-color: ${fade(theme.palette.background.default, 0.16)};
    `}
`;

interface RouteIconProps {
    icon: React.ComponentType<SvgIconProps>;
    isMatch?: boolean;
}

const RouteIcon = ({ icon, isMatch }: RouteIconProps) => {
    const Icon = icon;

    return isMatch
        ? (
            <CircleIcon>
                <Icon fontSize='small' />
            </CircleIcon>
        )
        : <Icon fontSize='small' htmlColor='#8993AA' />;
};

export default RouteIcon;
